import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 5V19M5 12H19", stroke: "black", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgPlus;
